
























import MoominWaveDivider
  from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominWaveDivider/MoominWaveDivider.vue";

export default {
  name: "SpotlightWaveDisplay",
  components: {MoominWaveDivider},
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    image: {
      type: Object,
    },
    color: {
      type: String,
    }
  },
  setup(props) {
  }
}
